import { render } from "./HomeV2AboutDispensaryCms.vue?vue&type=template&id=e854eb3c"
import script from "../js/home-v2-about-dispensary-cms.js?vue&type=script&lang=js"
export * from "../js/home-v2-about-dispensary-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__